import { useCustomTheme } from 'contexts/theme'
import React from 'react'

const LoginGirlSVG: React.FC<{}> = () => {
  const {
    theme: { setup },
  } = useCustomTheme()

  return (
    <>
      <svg width='480' height='391' viewBox='0 0 480 391' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_126_807)'>
          <path
            d='M333.71 52.3652C333.761 26.0413 312.464 4.66071 286.142 4.61018C259.82 4.55964 238.441 25.8583 238.39 52.1822L238.024 243.07C237.973 269.394 259.27 290.774 285.592 290.825C311.914 290.876 333.293 269.577 333.344 243.253L333.71 52.3652Z'
            fill='url(#paint0_linear_126_807)'
          />
          <path
            d='M286.254 100.016C312.418 100.066 333.669 78.8968 333.719 52.7326C333.77 26.5684 312.6 5.31737 286.436 5.26714L94.7225 4.89908C68.5582 4.84884 47.3072 26.0184 47.257 52.1826C47.2067 78.3469 68.3763 99.5979 94.5406 99.6481L286.254 100.016Z'
            fill='url(#paint1_linear_126_807)'
          />
          <g opacity='0.26'>
            <path
              d='M47.3156 3.98639L46.5831 385.514L47.5394 385.516L48.2719 3.98823L47.3156 3.98639Z'
              fill={setup.main}
            />
            <path
              d='M65.9622 3.53238L65.2279 386.017L66.1842 386.019L66.9185 3.53422L65.9622 3.53238Z'
              fill={setup.main}
            />
            <path
              d='M85.0905 3.5806L84.3562 386.065L85.3125 386.067L86.0468 3.58244L85.0905 3.5806Z'
              fill={setup.main}
            />
            <path
              d='M104.212 3.61515L103.478 386.099L104.434 386.101L105.168 3.61698L104.212 3.61515Z'
              fill={setup.main}
            />
            <path
              d='M123.333 3.64969L122.599 386.134L123.555 386.136L124.29 3.65153L123.333 3.64969Z'
              fill={setup.main}
            />
            <path
              d='M142.455 3.69791L141.72 386.182L142.677 386.184L143.411 3.69975L142.455 3.69791Z'
              fill={setup.main}
            />
            <path
              d='M161.576 3.73246L160.842 386.217L161.798 386.219L162.533 3.73429L161.576 3.73246Z'
              fill={setup.main}
            />
            <path
              d='M180.705 3.767L179.97 386.251L180.927 386.253L181.661 3.76884L180.705 3.767Z'
              fill={setup.main}
            />
            <path
              d='M199.819 3.80143L199.085 386.286L200.041 386.288L200.775 3.80326L199.819 3.80143Z'
              fill={setup.main}
            />
            <path
              d='M218.947 3.84977L218.213 386.334L219.169 386.336L219.904 3.8516L218.947 3.84977Z'
              fill={setup.main}
            />
            <path
              d='M238.069 3.88419L237.334 386.369L238.291 386.37L239.025 3.88603L238.069 3.88419Z'
              fill={setup.main}
            />
            <path
              d='M257.19 3.91874L256.456 386.403L257.412 386.405L258.146 3.92057L257.19 3.91874Z'
              fill={setup.main}
            />
            <path
              d='M276.318 3.96012L275.584 386.444L276.54 386.446L277.275 3.96195L276.318 3.96012Z'
              fill={setup.main}
            />
            <path
              d='M295.433 4.0015L294.699 386.486L295.655 386.488L296.389 4.00334L295.433 4.0015Z'
              fill={setup.main}
            />
            <path
              d='M314.561 4.03605L313.827 386.52L314.783 386.522L315.518 4.03788L314.561 4.03605Z'
              fill={setup.main}
            />
            <path
              d='M333.683 4.07059L332.948 386.555L333.905 386.557L334.639 4.07243L333.683 4.07059Z'
              fill={setup.main}
            />
            <path
              d='M352.804 4.11185L352.07 386.596L353.026 386.598L353.76 4.11369L352.804 4.11185Z'
              fill={setup.main}
            />
            <path
              d='M371.925 4.15329L371.191 386.638L372.147 386.64L372.882 4.15513L371.925 4.15329Z'
              fill={setup.main}
            />
            <path
              d='M391.047 4.18778L390.312 386.672L391.269 386.674L392.003 4.18962L391.047 4.18778Z'
              fill={setup.main}
            />
            <path
              d='M410.168 4.22928L409.434 386.714L410.39 386.715L411.125 4.23112L410.168 4.22928Z'
              fill={setup.main}
            />
            <path
              d='M428.82 4.73847L428.088 386.266L429.044 386.268L429.776 4.7403L428.82 4.73847Z'
              fill={setup.main}
            />
            <path
              d='M47.7996 3.53069L47.7977 4.487L429.326 5.21948L429.328 4.26317L47.7996 3.53069Z'
              fill={setup.main}
            />
            <path
              d='M47.2835 22.1756L47.2816 23.1319L429.766 23.8662L429.768 22.9099L47.2835 22.1756Z'
              fill={setup.main}
            />
            <path
              d='M47.2489 41.297L47.2471 42.2533L429.731 42.9876L429.733 42.0313L47.2489 41.297Z'
              fill={setup.main}
            />
            <path
              d='M47.2007 60.4252L47.1989 61.3815L429.683 62.1158L429.685 61.1596L47.2007 60.4252Z'
              fill={setup.main}
            />
            <path
              d='M47.1661 79.5398L47.1643 80.4961L429.649 81.2304L429.65 80.2741L47.1661 79.5398Z'
              fill={setup.main}
            />
            <path
              d='M47.1316 98.6681L47.1298 99.6244L429.614 100.359L429.616 99.4024L47.1316 98.6681Z'
              fill={setup.main}
            />
            <path
              d='M47.0971 117.789L47.0952 118.746L429.58 119.48L429.581 118.524L47.0971 117.789Z'
              fill={setup.main}
            />
            <path
              d='M47.0488 136.911L47.047 137.867L429.531 138.602L429.533 137.645L47.0488 136.911Z'
              fill={setup.main}
            />
            <path
              d='M47.0143 156.039L47.0125 156.995L429.497 157.73L429.499 156.774L47.0143 156.039Z'
              fill={setup.main}
            />
            <path
              d='M46.9799 175.154L46.978 176.11L429.462 176.844L429.464 175.888L46.9799 175.154Z'
              fill={setup.main}
            />
            <path
              d='M46.9385 194.282L46.9366 195.238L429.421 195.973L429.423 195.016L46.9385 194.282Z'
              fill={setup.main}
            />
            <path
              d='M46.8971 213.403L46.8953 214.36L429.38 215.094L429.381 214.138L46.8971 213.403Z'
              fill={setup.main}
            />
            <path
              d='M46.8626 232.525L46.8607 233.481L429.345 234.215L429.347 233.259L46.8626 232.525Z'
              fill={setup.main}
            />
            <path
              d='M46.828 251.653L46.8262 252.609L429.311 253.344L429.312 252.387L46.828 251.653Z'
              fill={setup.main}
            />
            <path
              d='M46.7798 270.768L46.778 271.724L429.262 272.458L429.264 271.502L46.7798 270.768Z'
              fill={setup.main}
            />
            <path
              d='M46.7452 289.896L46.7434 290.852L429.228 291.587L429.23 290.63L46.7452 289.896Z'
              fill={setup.main}
            />
            <path
              d='M46.7107 309.017L46.7089 309.974L429.193 310.708L429.195 309.752L46.7107 309.017Z'
              fill={setup.main}
            />
            <path
              d='M46.6763 328.139L46.6744 329.095L429.159 329.829L429.161 328.873L46.6763 328.139Z'
              fill={setup.main}
            />
            <path
              d='M46.6279 347.26L46.6261 348.216L429.11 348.951L429.112 347.994L46.6279 347.26Z'
              fill={setup.main}
            />
            <path
              d='M46.5935 366.388L46.5917 367.345L429.076 368.079L429.078 367.123L46.5935 366.388Z'
              fill={setup.main}
            />
            <path
              d='M47.3422 0.654566L47.3293 7.328L48.2856 7.32984L48.2985 0.656402L47.3422 0.654566Z'
              fill={setup.bg.light}
            />
            <path
              d='M44.4746 3.50415L44.4728 4.46045L51.1462 4.47326L51.1481 3.51696L44.4746 3.50415Z'
              fill={setup.bg.light}
            />
            <path
              d='M428.84 1.42041L428.827 8.09381L429.783 8.09565L429.796 1.42224L428.84 1.42041Z'
              fill={setup.main}
            />
            <path
              d='M425.972 4.27001L425.97 5.22632L432.644 5.23913L432.646 4.28282L425.972 4.27001Z'
              fill={setup.main}
            />
            <path
              d='M47.1489 96.0341L47.1361 102.708L48.0924 102.709L48.1052 96.036L47.1489 96.0341Z'
              fill={setup.bg.light}
            />
            <path
              d='M44.2814 98.8837L44.2795 99.84L50.953 99.8528L50.9548 98.8965L44.2814 98.8837Z'
              fill={setup.bg.light}
            />
            <path
              d='M428.646 96.7999L428.634 103.473L429.59 103.475L429.603 96.8018L428.646 96.7999Z'
              fill={setup.bg.light}
            />
            <path
              d='M425.779 99.6496L425.777 100.606L432.451 100.619L432.452 99.6624L425.779 99.6496Z'
              fill={setup.bg.light}
            />
            <path
              d='M46.9558 191.414L46.943 198.087L47.8993 198.089L47.9121 191.415L46.9558 191.414Z'
              fill={setup.bg.light}
            />
            <path
              d='M44.0883 194.263L44.0864 195.22L50.7599 195.232L50.7617 194.276L44.0883 194.263Z'
              fill={setup.bg.light}
            />
            <path
              d='M428.46 192.173L428.447 198.846L429.404 198.848L429.416 192.174L428.46 192.173Z'
              fill={setup.bg.light}
            />
            <path
              d='M425.593 195.022L425.591 195.979L432.264 195.991L432.266 195.035L425.593 195.022Z'
              fill={setup.bg.light}
            />
            <path
              d='M46.7694 286.779L46.7566 293.453L47.7129 293.455L47.7257 286.781L46.7694 286.779Z'
              fill={setup.bg.light}
            />
            <path
              d='M43.902 289.629L43.9001 290.585L50.5736 290.598L50.5754 289.642L43.902 289.629Z'
              fill={setup.bg.light}
            />
            <path
              d='M428.267 287.545L428.254 294.219L429.211 294.221L429.223 287.547L428.267 287.545Z'
              fill={setup.bg.light}
            />
            <path
              d='M425.4 290.395L425.398 291.351L432.071 291.364L432.073 290.408L425.4 290.395Z'
              fill={setup.bg.light}
            />
            <path
              d='M46.559 385.744L46.5571 386.701L429.041 387.435L429.043 386.479L46.559 385.744Z'
              fill={setup.main}
            />
            <path
              d='M142.715 0.847732L142.702 7.52118L143.658 7.52302L143.671 0.849568L142.715 0.847732Z'
              fill={setup.bg.light}
            />
            <path
              d='M139.847 3.69733L139.845 4.65363L146.519 4.66644L146.521 3.71014L139.847 3.69733Z'
              fill={setup.bg.light}
            />
            <path
              d='M142.529 96.2273L142.516 102.901L143.472 102.903L143.485 96.2291L142.529 96.2273Z'
              fill={setup.bg.light}
            />
            <path
              d='M139.661 99.077L139.659 100.033L146.333 100.046L146.334 99.0898L139.661 99.077Z'
              fill={setup.bg.light}
            />
            <path
              d='M142.335 191.6L142.323 198.273L143.279 198.275L143.292 191.602L142.335 191.6Z'
              fill={setup.bg.light}
            />
            <path
              d='M139.468 194.45L139.466 195.406L146.139 195.419L146.141 194.462L139.468 194.45Z'
              fill={setup.bg.light}
            />
            <path
              d='M142.142 286.973L142.129 293.646L143.086 293.648L143.098 286.974L142.142 286.973Z'
              fill={setup.bg.light}
            />
            <path
              d='M139.275 289.822L139.273 290.779L145.946 290.791L145.948 289.835L139.275 289.822Z'
              fill={setup.bg.light}
            />
            <path
              d='M238.094 1.04091L238.082 7.71436L239.038 7.71619L239.051 1.04274L238.094 1.04091Z'
              fill={setup.bg.light}
            />
            <path
              d='M235.227 3.89056L235.225 4.84686L241.898 4.85967L241.9 3.90337L235.227 3.89056Z'
              fill={setup.bg.light}
            />
            <path
              d='M237.901 96.4136L237.888 103.087L238.845 103.089L238.858 96.4154L237.901 96.4136Z'
              fill={setup.bg.light}
            />
            <path
              d='M235.034 99.2632L235.032 100.219L241.705 100.232L241.707 99.276L235.034 99.2632Z'
              fill={setup.bg.light}
            />
            <path
              d='M237.715 191.793L237.702 198.467L238.658 198.468L238.671 191.795L237.715 191.793Z'
              fill={setup.bg.light}
            />
            <path
              d='M234.847 194.643L234.845 195.599L241.519 195.612L241.521 194.656L234.847 194.643Z'
              fill={setup.bg.light}
            />
            <path
              d='M237.522 287.166L237.509 293.839L238.465 293.841L238.478 287.168L237.522 287.166Z'
              fill={setup.bg.light}
            />
            <path
              d='M234.654 290.015L234.652 290.972L241.326 290.984L241.328 290.028L234.654 290.015Z'
              fill={setup.bg.light}
            />
            <path
              d='M333.46 1.22715L333.447 7.90057L334.404 7.90241L334.416 1.22898L333.46 1.22715Z'
              fill={setup.bg.light}
            />
            <path
              d='M330.593 4.0768L330.591 5.03308L337.264 5.04589L337.266 4.08961L330.593 4.0768Z'
              fill={setup.bg.light}
            />
            <path
              d='M333.274 96.6067L333.261 103.28L334.217 103.282L334.23 96.6086L333.274 96.6067Z'
              fill={setup.bg.light}
            />
            <path
              d='M330.406 99.4564L330.404 100.413L337.078 100.425L337.08 99.4692L330.406 99.4564Z'
              fill={setup.bg.light}
            />
            <path
              d='M333.081 191.986L333.068 198.66L334.024 198.662L334.037 191.988L333.081 191.986Z'
              fill={setup.bg.light}
            />
            <path
              d='M330.213 194.836L330.211 195.792L336.885 195.805L336.887 194.849L330.213 194.836Z'
              fill={setup.bg.light}
            />
            <path
              d='M332.887 287.352L332.875 294.026L333.831 294.027L333.844 287.354L332.887 287.352Z'
              fill={setup.bg.light}
            />
            <path
              d='M330.02 290.202L330.018 291.158L336.692 291.171L336.693 290.215L330.02 290.202Z'
              fill={setup.bg.light}
            />
            <path
              d='M428.074 383.635L428.061 390.308L429.017 390.31L429.03 383.637L428.074 383.635Z'
              fill={setup.bg.light}
            />
            <path
              d='M425.206 386.484L425.205 387.441L431.878 387.454L431.88 386.497L425.206 386.484Z'
              fill={setup.bg.light}
            />
            <path
              d='M46.5763 382.869L46.5635 389.542L47.5198 389.544L47.5326 382.871L46.5763 382.869Z'
              fill={setup.bg.light}
            />
            <path
              d='M43.7087 385.719L43.7069 386.675L50.3804 386.688L50.3822 385.731L43.7087 385.719Z'
              fill={setup.bg.light}
            />
            <path
              d='M141.949 383.062L141.936 389.736L142.892 389.737L142.905 383.064L141.949 383.062Z'
              fill={setup.main}
            />
            <path
              d='M139.081 385.912L139.08 386.868L145.753 386.881L145.755 385.925L139.081 385.912Z'
              fill={setup.main}
            />
            <path
              d='M234.461 386.105L234.459 387.061L241.133 387.074L241.134 386.118L234.461 386.105Z'
              fill={setup.bg.light}
            />
            <path
              d='M332.701 383.442L332.688 390.115L333.645 390.117L333.657 383.444L332.701 383.442Z'
              fill={setup.bg.light}
            />
            <path
              d='M329.834 386.291L329.832 387.248L336.505 387.26L336.507 386.304L329.834 386.291Z'
              fill={setup.bg.light}
            />
            <path
              d='M94.9264 51.2994L94.9246 52.2557L95.8809 52.2576L95.8827 51.3013L94.9264 51.2994Z'
              fill={setup.main}
            />
            <path
              d='M190.306 51.4858L190.304 52.4421L191.26 52.4439L191.262 51.4876L190.306 51.4858Z'
              fill={setup.main}
            />
            <path
              d='M285.672 51.6789L285.67 52.6353L286.626 52.6371L286.628 51.6808L285.672 51.6789Z'
              fill={setup.main}
            />
            <path
              d='M381.051 51.8721L381.049 52.8284L382.006 52.8303L382.008 51.874L381.051 51.8721Z'
              fill={setup.main}
            />
            <path
              d='M94.7332 146.672L94.7313 147.628L95.6876 147.63L95.6895 146.674L94.7332 146.672Z'
              fill={setup.main}
            />
            <path
              d='M190.113 146.865L190.111 147.822L191.067 147.823L191.069 146.867L190.113 146.865Z'
              fill={setup.main}
            />
            <path
              d='M285.485 147.052L285.484 148.008L286.44 148.01L286.442 147.053L285.485 147.052Z'
              fill={setup.main}
            />
            <path
              d='M380.858 147.245L380.856 148.201L381.812 148.203L381.814 147.247L380.858 147.245Z'
              fill={setup.main}
            />
            <path
              d='M94.5469 242.052L94.545 243.008L95.5014 243.01L95.5032 242.054L94.5469 242.052Z'
              fill={setup.main}
            />
            <path
              d='M189.92 242.238L189.918 243.194L190.874 243.196L190.876 242.24L189.92 242.238Z'
              fill={setup.main}
            />
            <path
              d='M285.292 242.431L285.29 243.387L286.247 243.389L286.249 242.433L285.292 242.431Z'
              fill={setup.main}
            />
            <path
              d='M380.672 242.617L380.67 243.574L381.626 243.576L381.628 242.619L380.672 242.617Z'
              fill={setup.main}
            />
            <path
              d='M94.3538 337.417L94.3519 338.374L95.3082 338.376L95.3101 337.419L94.3538 337.417Z'
              fill={setup.main}
            />
            <path
              d='M189.733 337.611L189.731 338.567L190.688 338.569L190.69 337.612L189.733 337.611Z'
              fill={setup.main}
            />
            <path
              d='M285.106 337.804L285.104 338.76L286.06 338.762L286.062 337.806L285.106 337.804Z'
              fill={setup.main}
            />
            <path
              d='M380.479 337.99L380.477 338.946L381.433 338.948L381.435 337.992L380.479 337.99Z'
              fill={setup.main}
            />
          </g>
          <path
            d='M98.9315 194.451C123.176 194.497 142.828 214.218 142.782 238.47L142.58 343.422C142.534 367.666 122.813 387.318 98.5613 387.272L90.4087 387.256C66.1641 387.21 46.5118 367.489 46.5584 343.237L46.7442 246.445C46.7994 217.694 70.1806 194.402 98.9314 194.458L98.9315 194.451Z'
            fill='url(#paint2_linear_126_807)'
          />
          <path
            d='M383.416 147.16L383.416 147.166C383.365 173.68 404.818 195.215 431.332 195.266L431.339 195.266C457.852 195.317 479.387 173.865 479.438 147.351L479.438 147.344C479.489 120.83 458.037 99.2952 431.523 99.2443L431.516 99.2443C405.002 99.1934 383.467 120.646 383.416 147.16Z'
            fill='url(#paint3_linear_126_807)'
          />
          <path
            d='M217.288 290.26C243.517 290.31 264.821 269.089 264.871 242.86C264.921 216.631 243.699 195.328 217.471 195.277L94.4522 195.041C68.2234 194.991 46.9199 216.212 46.8696 242.441C46.8192 268.67 68.0411 289.974 94.2699 290.024L217.288 290.26Z'
            fill='url(#paint4_linear_126_807)'
          />
          <path
            d='M380.919 386.688C407.346 386.739 428.81 365.357 428.861 338.931C428.911 312.504 407.53 291.041 381.103 290.99L208.901 290.659C182.475 290.608 161.011 311.99 160.96 338.417C160.909 364.843 182.291 386.307 208.717 386.358L380.919 386.688Z'
            fill='url(#paint5_linear_126_807)'
          />
          <g filter='url(#filter0_d_126_807)'>
            <path
              d='M94.7423 290.463C121.256 290.463 142.75 268.969 142.75 242.455C142.75 215.941 121.256 194.447 94.7423 194.447C68.2285 194.447 46.7347 215.941 46.7347 242.455C46.7347 268.969 68.2285 290.463 94.7423 290.463Z'
              stroke='#0F0F1E'
              strokeWidth='1.54'
              strokeMiterlimit='10'
            />
          </g>
          <g opacity='0.22' filter='url(#filter1_d_126_807)'>
            <path
              d='M333.081 52.7226C334.257 76.7607 313.838 99.7601 285.858 99.7601C259.831 99.7601 238.772 78.5633 238.82 52.5368C238.875 26.5103 260.017 5.45113 286.043 5.49929C312.07 5.55433 331.808 26.7236 333.081 52.7226Z'
              fill={setup.main}
            />
          </g>
          <g opacity='0.31' filter='url(#filter2_d_126_807)'>
            <path
              d='M95.8844 100.269C122.398 100.269 143.892 78.7754 143.892 52.2616C143.892 25.7477 122.398 4.25403 95.8844 4.25403C69.3706 4.25403 47.8768 25.7477 47.8768 52.2616C47.8768 78.7754 69.3706 100.269 95.8844 100.269Z'
              fill={setup.main}
            />
          </g>
          <g filter='url(#filter3_d_126_807)'>
            <path
              d='M431.463 195.266C457.977 195.266 479.47 173.772 479.47 147.258C479.47 120.745 457.977 99.2509 431.463 99.2509C404.949 99.2509 383.455 120.745 383.455 147.258C383.455 173.772 404.949 195.266 431.463 195.266Z'
              stroke={setup.bg.main}
              strokeWidth='1.54'
              strokeMiterlimit='10'
            />
          </g>
          <g filter='url(#filter4_d_126_807)'>
            <path
              d='M381.143 386.987C407.657 386.987 429.151 365.493 429.151 338.979C429.151 312.465 407.657 290.972 381.143 290.972C354.63 290.972 333.136 312.465 333.136 338.979C333.136 365.493 354.63 386.987 381.143 386.987Z'
              stroke='url(#paint6_linear_126_807)'
              strokeWidth='1.54'
              strokeMiterlimit='10'
            />
          </g>
          <path
            d='M410.582 193.553C410.479 193.574 410.369 193.574 410.266 193.553L383.902 184.575C383.593 184.465 383.352 184.21 383.263 183.887C383.166 183.563 383.242 183.219 383.462 182.965C383.682 182.731 404.487 158.81 407.92 148.311C410.851 139.381 419.244 121.893 423.613 121.246C424.363 121.136 425.106 121.466 425.525 122.099C427.197 124.541 425.106 132.315 422.98 138.445C429.681 129.213 441.136 115.109 446.282 118.343C450.74 121.555 453.808 126.351 454.861 131.744C455.866 135.673 455.205 139.835 453.052 143.268C448.029 150.575 412.853 191.51 411.346 193.25C411.147 193.45 410.871 193.56 410.589 193.553H410.582Z'
            fill='white'
          />
          <path
            d='M410.582 193.553C410.479 193.574 410.369 193.574 410.266 193.553L383.902 184.575C383.593 184.465 383.352 184.21 383.263 183.887C383.166 183.563 383.242 183.219 383.462 182.965C383.682 182.731 404.487 158.81 407.92 148.311C410.851 139.381 419.244 121.893 423.613 121.246C424.363 121.136 425.106 121.466 425.525 122.099C427.197 124.541 425.106 132.315 422.98 138.445C429.681 129.213 441.136 115.109 446.282 118.343C450.74 121.555 453.808 126.351 454.861 131.744C455.866 135.673 455.205 139.835 453.052 143.268C448.029 150.575 412.853 191.51 411.346 193.25C411.147 193.45 410.871 193.56 410.589 193.553H410.582ZM385.925 183.116L410.266 191.406C414.421 186.563 446.715 148.896 451.421 142.092C453.272 139.085 453.808 135.453 452.914 132.04C451.958 127.19 449.226 122.876 445.257 119.932C442.98 118.542 433.664 125.711 420.132 146.096C419.76 146.495 419.134 146.515 418.735 146.144C418.467 145.889 418.357 145.511 418.46 145.16C421.707 137.338 425.594 125.346 424.074 123.186C421.913 123.186 413.72 137.51 409.984 148.882C406.737 158.562 390.17 178.177 385.932 183.123L385.925 183.116Z'
            fill='#262235'
          />
          <path
            d='M301.757 360.203L305.307 386.168C305.307 386.168 146.431 388.046 148.323 386.168C150.215 384.29 148.323 346.203 148.323 346.203L301.757 360.203Z'
            fill='#262235'
          />
          <path
            d='M186.932 388.012C147.985 388.012 147.717 387.358 147.401 386.588C147.242 386.203 147.325 385.762 147.621 385.466C148.577 383.671 148.206 363.912 147.339 346.251C147.311 345.708 147.724 345.24 148.274 345.212C148.323 345.212 148.364 345.212 148.412 345.212L301.86 359.213C302.314 359.261 302.679 359.612 302.748 360.066L306.298 386.031C306.332 386.306 306.249 386.588 306.064 386.801C305.885 387.021 305.61 387.152 305.328 387.152C304.928 387.152 265.817 387.62 227.104 387.854C210.468 387.957 197.355 388.005 186.939 388.005L186.932 388.012ZM149.561 385.466C159.427 386.491 245.659 385.865 304.165 385.184L300.814 361.132L149.306 347.297C149.994 360.128 150.696 379.894 149.561 385.473V385.466Z'
            fill='#262235'
          />
          <path
            d='M246.195 46.8884C245.824 46.283 245.459 45.6844 245.074 45.079C237.857 34.1056 225.397 27.7418 212.278 28.3266C206.939 28.5467 201.641 29.3654 196.481 30.7552C191.273 32.2274 189.464 36.8851 185.04 39.1279C184.098 39.5201 183.093 39.7196 182.075 39.7127C178.828 39.9742 175.649 40.7722 172.663 42.0725C164.525 45.6088 159.076 56.933 156.145 64.7691C150.634 80.18 147.229 96.2582 146.011 112.577C144.656 127.651 142.881 144.534 148.591 159.023C154.088 173.471 162.137 186.818 172.361 198.417C191.308 219.201 219.749 231.53 247.736 229.273C264.489 227.918 280.347 221.705 295.104 213.828C303.58 209.308 311.953 204.065 317.732 196.387C328.636 181.947 327.783 159.986 316.06 146.137C303.449 131.063 283.601 124.631 271.018 109.289C257.148 92.2541 257.65 65.8217 246.195 46.8746V46.8884Z'
            fill='white'
          />
          <path
            d='M241.269 230.622C215.793 230.622 189.608 218.898 171.625 199.201C161.298 187.533 153.187 174.083 147.69 159.505C142.076 145.318 143.569 128.82 144.889 114.276L145.041 112.605C146.245 96.2031 149.664 80.0355 155.209 64.549C158.443 55.9079 164.036 44.852 172.278 41.2676C175.367 39.926 178.656 39.1073 182.013 38.839H182.281C183.066 38.8321 183.843 38.6808 184.579 38.3849C186.265 37.4286 187.778 36.1971 189.065 34.7524C190.95 32.5164 193.42 30.8446 196.199 29.9296C201.435 28.5055 206.808 27.673 212.229 27.4528C225.693 26.8543 238.483 33.3626 245.934 44.5905C246.333 45.196 246.704 45.8152 247.076 46.4137C252.284 55.0548 255.063 65.3402 257.781 75.2747C261.014 87.1837 264.365 99.4986 271.871 108.773C278.152 116.478 286.477 122.058 294.533 127.431C302.589 132.804 310.597 138.184 316.893 145.69C328.884 159.979 329.62 182.538 318.564 197.199C312.483 205.276 303.491 210.601 295.613 214.901C278.207 224.182 262.597 229.259 247.86 230.463C245.679 230.546 243.471 230.628 241.276 230.628L241.269 230.622ZM213.647 29.3654H212.305C207.042 29.6062 201.827 30.4249 196.743 31.8078C194.301 32.654 192.14 34.1469 190.475 36.1283C189.024 37.7245 187.331 39.0729 185.453 40.1324C184.49 40.5521 183.451 40.7791 182.405 40.7997H182.123C178.986 41.0543 175.911 41.818 173.028 43.077C165.522 46.3793 160.163 56.9261 157.149 65.3058C151.673 80.6272 148.288 96.6159 147.098 112.845L146.947 114.517C145.66 128.855 144.181 145.105 149.609 158.872C155.03 173.216 163.018 186.46 173.179 197.949C192.326 218.953 220.919 230.649 247.805 228.482C262.26 227.312 277.622 222.304 294.705 213.154C302.459 209.033 311.155 203.756 317.016 196.002C327.501 182.098 326.779 160.557 315.345 146.956C309.228 139.67 301.172 134.276 293.384 129.068C285.211 123.606 276.769 117.964 270.288 110.004C262.535 100.489 259.116 87.9748 255.834 75.8663C253.171 66.0488 250.406 55.9148 245.349 47.5076C244.998 46.9022 244.627 46.3174 244.241 45.7326C237.472 35.4541 225.962 29.2898 213.654 29.3517L213.647 29.3654Z'
            fill='#262235'
          />
          <path
            d='M141.154 369.87C135.478 333.021 113.882 181.362 138.725 157.138C167.05 129.502 244.936 130.706 259.212 155.7C266.966 169.253 288.775 192.067 290.453 221.712C292.834 263.776 305.362 342.914 308.362 369.904L141.161 369.87H141.154Z'
            fill={setup.bg.main}
          />
          <path d='M204.015 369.87L186.63 155.666L230.867 160.337L254.919 369.87H204.015Z' fill='#262235' />
          <path
            d='M254.919 370.86H204.049C203.54 370.86 203.114 370.468 203.059 369.959L185.618 155.776C185.57 155.239 185.962 154.764 186.492 154.716C186.561 154.716 186.636 154.716 186.705 154.716L230.943 159.388C231.404 159.436 231.768 159.8 231.83 160.261L255.965 369.76C255.999 370.042 255.916 370.317 255.731 370.53C255.524 370.764 255.222 370.881 254.912 370.867L254.919 370.86ZM204.937 368.886H253.811L229.973 161.183L187.71 156.711L204.93 368.886H204.937Z'
            fill='#262235'
          />
          <path
            d='M228.342 132.687L230.853 160.344C230.853 160.344 222.48 169.989 211.156 170.898C192.732 172.391 186.616 155.673 186.616 155.673C185.893 142.855 185.075 130.059 184.387 117.262C183.919 108.539 179.227 90.5961 187.572 84.7482C189.884 83.0764 192.594 82.0994 194.961 80.6134C202.199 75.9833 206.182 67.6449 205.226 59.107C208.322 62.8909 211.624 66.8262 216.144 68.7044C219.976 69.9909 224.021 70.5 228.053 70.1973C232.036 70.1973 236.962 69.3098 240.87 70.0666C245.06 70.8853 243.753 70.0666 244.84 73.6854C246.126 78.0541 245.493 84.0052 245.776 88.5596C246.278 96.8017 247 105.092 247 113.348C246.23 127.871 228.342 132.694 228.342 132.694V132.687Z'
            fill='white'
          />
          <path
            d='M208.893 171.978C191.693 171.978 185.763 156.168 185.694 155.996C185.68 155.9 185.68 155.803 185.694 155.714C185.357 149.935 185.027 144.169 184.669 138.397C184.256 131.387 183.85 124.355 183.444 117.31C183.444 115.515 183.073 113.258 182.777 110.864C181.587 101.604 179.977 88.9036 187.063 83.9295C188.418 83.0213 189.842 82.2095 191.315 81.5009C192.388 80.9505 193.496 80.3932 194.5 79.8291C201.38 75.3916 205.171 67.4523 204.297 59.3134C204.242 58.8731 204.483 58.4534 204.882 58.2745C205.295 58.0888 205.776 58.2057 206.051 58.5566C208.913 62.0585 212.181 66.0281 216.571 67.8513C220.286 69.069 224.207 69.5506 228.115 69.2754C229.388 69.2754 230.743 69.1585 232.188 69.0553C235.153 68.7113 238.16 68.7457 241.118 69.1585L242.645 69.4268C244.64 69.7776 245.06 69.9978 245.425 71.7384C245.507 72.1374 245.624 72.7085 245.844 73.4102C246.642 76.8432 246.945 80.3726 246.746 83.8951V88.5183C246.863 90.4585 247 92.4054 247.131 94.3456C247.53 100.579 247.97 107.011 247.97 113.355C247.234 126.757 232.897 132.267 229.36 133.457L231.823 160.261C231.851 160.53 231.761 160.798 231.589 160.998C231.238 161.397 222.776 170.966 211.218 171.888C210.434 171.957 209.663 171.992 208.893 171.992V171.978ZM187.606 155.445C188.246 157.117 194.307 171.221 211.06 169.9C220.692 169.129 228.28 161.527 229.821 159.986L227.31 132.77C227.269 132.288 227.578 131.854 228.046 131.731C228.211 131.731 245.246 126.908 245.989 113.306C245.989 107.094 245.569 100.696 245.149 94.4969C245.019 92.5362 244.895 90.5961 244.778 88.6491C244.675 87.1561 244.695 85.5806 244.695 83.9088C244.874 80.579 244.599 77.2423 243.877 73.995C243.684 73.3758 243.526 72.7429 243.409 72.103C243.368 71.8966 243.319 71.6902 243.258 71.4838C242.914 71.4701 242.57 71.4288 242.232 71.3531L240.657 71.0848C237.877 70.7339 235.064 70.7339 232.284 71.0848C230.812 71.188 229.422 71.2843 228.094 71.305C223.925 71.6214 219.742 71.0917 215.779 69.7501C212.078 67.9407 208.858 65.2782 206.382 61.9759C206.189 69.8464 202.123 77.1116 195.511 81.3908C194.424 82.0582 193.282 82.6498 192.161 83.2002C190.771 83.8744 189.43 84.6381 188.143 85.4981C182.048 89.7842 183.568 101.796 184.676 110.623C184.992 113.052 185.281 115.35 185.377 117.221C185.749 124.232 186.155 131.256 186.602 138.294C186.946 144.025 187.283 149.749 187.606 155.466V155.445Z'
            fill='#262235'
          />
          <path
            d='M195.677 101.549C193.585 95.6665 185.893 91.4973 179.777 93.004C171.886 95.0336 172.856 104.108 175.938 109.756C179.86 116.856 188.797 119.436 195.897 115.515C195.945 115.487 195.986 115.467 196.034 115.439'
            fill='white'
          />
          <path
            d='M188.776 118.294C183.066 118.294 177.816 115.185 175.058 110.19C173.179 106.839 171.707 101.246 173.503 96.9393C174.617 94.4419 176.853 92.6188 179.53 92.0477C186.031 90.3759 194.335 94.8272 196.598 101.212C196.784 101.728 196.516 102.299 195.993 102.484C195.47 102.67 194.906 102.402 194.72 101.879C192.264 96.1344 186.162 92.8458 180.011 93.9535C177.94 94.4006 176.2 95.7973 175.319 97.7236C173.847 101.074 175.003 105.966 176.791 109.213C180.431 115.838 188.749 118.26 195.374 114.621C195.436 114.586 195.491 114.552 195.553 114.524C196.014 114.249 196.612 114.393 196.887 114.854C196.894 114.868 196.901 114.882 196.908 114.896C197.183 115.37 197.025 115.976 196.55 116.244C196.55 116.244 196.55 116.244 196.543 116.244C194.17 117.579 191.494 118.281 188.769 118.287L188.776 118.294Z'
            fill='#262235'
          />
          <path
            d='M225.824 84.5281C225.824 84.5281 237.417 97.5929 235.47 100.393C233.523 103.193 226.89 102.436 226.89 102.436'
            fill='white'
          />
          <path
            d='M229.023 103.523C227.916 103.523 227.083 103.523 226.842 103.42C226.299 103.351 225.914 102.856 225.969 102.312C226.017 101.776 226.491 101.384 227.028 101.439C227.042 101.439 227.062 101.439 227.076 101.439C228.631 101.624 233.406 101.707 234.713 99.7669C235.497 98.6249 230.943 91.6418 225.15 85.1129C224.73 84.7482 224.689 84.1153 225.054 83.6956C225.418 83.2759 226.051 83.2347 226.471 83.5993C226.533 83.6543 226.595 83.7231 226.643 83.7919C230.275 87.8923 238.517 97.7787 236.357 100.895C234.85 103.138 231.349 103.523 229.023 103.523Z'
            fill='#262235'
          />
          <path
            d='M228.342 132.687C228.342 132.687 218.008 135.618 204.71 128.614C204.71 128.614 211.211 147.623 229.704 147.657L228.349 132.68L228.342 132.687Z'
            fill='#262235'
          />
          <path
            d='M229.697 148.648C210.716 148.648 203.836 129.137 203.767 128.931C203.63 128.545 203.753 128.119 204.07 127.857C204.373 127.589 204.813 127.534 205.178 127.727C217.96 134.428 227.957 131.765 228.06 131.731C228.342 131.648 228.652 131.696 228.899 131.861C229.147 132.027 229.305 132.302 229.333 132.598L230.688 147.554C230.743 148.098 230.351 148.579 229.807 148.641C229.773 148.641 229.739 148.641 229.704 148.641L229.697 148.648ZM206.698 130.644C209.078 135.487 215.69 146.006 228.61 146.591L227.454 133.843C220.375 134.882 213.144 133.767 206.698 130.644Z'
            fill='#262235'
          />
          <path
            d='M211.101 91.4285C212.165 91.4285 213.028 89.4633 213.028 87.0392C213.028 84.615 212.165 82.6498 211.101 82.6498C210.037 82.6498 209.175 84.615 209.175 87.0392C209.175 89.4633 210.037 91.4285 211.101 91.4285Z'
            fill='#262235'
          />
          <path
            d='M236.66 88.8732C237.723 88.8135 238.473 86.803 238.337 84.3826C238.201 81.9623 237.229 80.0487 236.167 80.1084C235.105 80.1682 234.354 82.1787 234.49 84.599C234.627 87.0194 235.598 88.933 236.66 88.8732Z'
            fill='#262235'
          />
          <path
            d='M326.731 225.028C333.968 221.409 391.518 158.363 391.518 158.363L425.016 186.419C424.411 191.028 371.814 301.009 341.027 295.395C310.24 289.781 244.179 250.374 244.179 250.374L259.253 155.666C259.253 155.666 319.472 228.647 326.724 225.028H326.731Z'
            fill={setup.bg.main}
          />
          <path
            d='M305.307 347.187C304.825 347.187 304.419 346.836 304.337 346.368L278.159 194.709C278.07 194.165 278.427 193.656 278.971 193.56C279.514 193.464 280.023 193.828 280.12 194.372L306.236 346.031C306.332 346.561 305.988 347.063 305.458 347.166C305.451 347.166 305.438 347.166 305.431 347.166L305.314 347.18L305.307 347.187Z'
            fill='#262235'
          />
          <path
            d='M217.706 303.17C217.823 302.213 225.459 301.161 226.553 300.844C230.42 299.702 234.479 298.966 238.428 298.161C246.12 296.62 254.341 294.927 262.212 295.629C276.033 296.888 259.061 305.681 259.061 305.681C259.061 305.681 291.121 297.507 289.208 305.681C287.295 313.854 272.222 321.408 262.789 323.919C253.357 326.43 215.002 323.919 215.002 323.919L217.699 303.163L217.706 303.17Z'
            fill='white'
          />
          <path
            d='M246.126 325.997C232.36 325.997 215.979 324.944 214.968 324.875C214.699 324.855 214.445 324.724 214.266 324.525C214.094 324.311 214.018 324.043 214.046 323.768C214.046 323.768 216.694 303.163 216.708 303.011C216.86 301.856 218.236 301.34 224.379 300.246C225.28 300.081 226.051 299.943 226.271 299.86C229.622 298.89 233.123 298.189 236.508 297.514L238.655 297.081C246.408 295.526 254.417 293.916 262.287 294.618C264.764 294.852 268.114 295.423 268.568 297.714C268.94 299.592 266.897 301.649 264.681 303.342C272.655 301.67 285.988 299.475 289.373 302.791C290.199 303.589 290.515 304.786 290.192 305.887C288.197 314.514 273.137 322.172 263.071 324.848C259.824 325.701 253.323 325.99 246.12 325.99L246.126 325.997ZM216.144 322.963C222.377 323.348 254.265 325.144 262.576 322.963C272.256 320.383 286.559 312.911 288.272 305.461C288.437 305.027 288.327 304.539 287.99 304.222C285.108 301.395 268.864 304.222 259.294 306.651C258.806 306.768 258.311 306.499 258.139 306.032C257.953 305.564 258.159 305.034 258.606 304.807C262.693 302.681 266.979 299.496 266.628 298.106C266.525 297.59 265.287 296.881 262.108 296.599C254.52 295.911 246.663 297.501 239.04 299.028L236.894 299.461C233.543 300.115 230.096 300.803 226.842 301.773C226.539 301.856 225.735 302.007 224.751 302.193C222.687 302.509 220.65 302.977 218.655 303.603C218.339 305.88 216.646 319.131 216.144 322.97V322.963Z'
            fill='#262235'
          />
          <path
            d='M134.639 163.406C133.985 165.077 74.0202 307.71 104.491 326.417C134.962 345.13 229.766 337.872 229.766 337.872L225.831 295.595L149.699 285.378L134.639 163.406Z'
            fill={setup.bg.main}
          />
          <path
            d='M222.474 296.586H222.308L132.994 282.434C132.451 282.344 132.086 281.835 132.176 281.292C132.265 280.748 132.774 280.384 133.318 280.473L222.632 294.625C223.168 294.707 223.533 295.21 223.451 295.746C223.382 296.228 222.969 296.586 222.48 296.586H222.474Z'
            fill='#262235'
          />
          <path
            d='M145.158 282.447C144.614 282.447 144.167 282.007 144.167 281.457C143.913 257.838 150.435 198.355 150.497 197.708C150.572 197.172 151.061 196.786 151.604 196.835C152.148 196.897 152.533 197.385 152.478 197.922C152.478 198.527 145.915 257.886 146.149 281.388C146.169 281.925 145.75 282.372 145.213 282.392C145.199 282.392 145.192 282.392 145.179 282.392L145.165 282.441L145.158 282.447Z'
            fill='#262235'
          />
          <path d='M326.394 302.516H213.399L233.082 232.452H346.077L326.394 302.516Z' fill='white' />
          <path
            d='M326.332 303.507H213.399C213.089 303.507 212.8 303.362 212.615 303.121C212.429 302.874 212.367 302.55 212.45 302.248L232.147 232.183C232.264 231.764 232.649 231.468 233.082 231.461H346.077C346.386 231.461 346.682 231.612 346.861 231.86C347.047 232.101 347.109 232.417 347.026 232.713L327.329 302.777C327.205 303.225 326.786 303.52 326.325 303.5L326.332 303.507ZM214.706 301.498H325.644L344.756 233.442H233.832L214.706 301.498Z'
            fill='#262235'
          />
          <path d='M327.488 302.516H183.066V308.281H327.488V302.516Z' fill='white' />
          <path
            d='M327.487 309.265H183.066C182.529 309.272 182.089 308.845 182.075 308.309C182.075 308.295 182.075 308.288 182.075 308.274V302.509C182.068 301.973 182.495 301.532 183.031 301.518C183.045 301.518 183.052 301.518 183.066 301.518H327.487C328.031 301.518 328.478 301.959 328.478 302.509V308.274C328.478 308.818 328.038 309.265 327.487 309.265ZM184.056 307.291H326.435V303.507H184.056V307.291Z'
            fill='#262235'
          />
          <path d='M215.078 302.516H183.066V308.281H215.078V302.516Z' fill='white' />
          <path
            d='M215.071 309.265H183.059C182.522 309.272 182.082 308.845 182.068 308.309C182.068 308.295 182.068 308.288 182.068 308.274V302.509C182.061 301.972 182.488 301.532 183.024 301.518C183.038 301.518 183.045 301.518 183.059 301.518H215.071C215.607 301.512 216.048 301.938 216.061 302.475C216.061 302.488 216.061 302.495 216.061 302.509V308.274C216.068 308.811 215.642 309.251 215.105 309.265C215.091 309.265 215.085 309.265 215.071 309.265ZM184.05 307.291H214.101V303.507H184.05V307.291Z'
            fill='#262235'
          />
          <path
            d='M246.23 308.481C253.247 306.252 259.363 301.931 265.693 298.161C270.715 295.127 276.343 292.279 282.308 291.46C284.537 291.343 286.773 291.343 289.008 291.46C290.969 291.46 293.714 290.676 295.056 292.63C297.65 296.4 295.675 305.777 281.104 315.361'
            fill='white'
          />
          <path
            d='M281.104 316.4C280.56 316.393 280.12 315.945 280.127 315.395C280.127 315.072 280.292 314.769 280.567 314.59C288.609 309.3 293.817 303.232 294.856 297.955C295.29 296.365 295.07 294.666 294.237 293.249C293.535 292.21 292.146 292.244 290.254 292.41H289.063C288.107 292.458 287.151 292.458 286.201 292.41C284.956 292.286 283.697 292.286 282.452 292.41C276.659 293.503 271.141 295.732 266.222 298.973C264.915 299.743 263.608 300.548 262.301 301.353C257.396 304.669 252.105 307.366 246.539 309.396C246.016 309.547 245.466 309.258 245.301 308.742C245.136 308.226 245.418 307.669 245.941 307.504C251.348 305.523 256.494 302.894 261.269 299.668L265.204 297.274C270.061 294.391 275.875 291.329 282.17 290.456C283.553 290.311 284.942 290.311 286.325 290.456C287.247 290.456 288.1 290.559 288.988 290.456H290.075C291.919 290.304 294.464 290.07 295.888 292.127C297.017 293.992 297.347 296.228 296.81 298.34C296.143 301.69 293.295 308.591 281.654 316.228C281.496 316.338 281.31 316.4 281.117 316.393L281.104 316.4Z'
            fill='#262235'
          />
          <path
            d='M464.465 67.528H376.066C375.557 67.5211 375.151 67.1014 375.158 66.5923C375.158 66.5166 375.172 66.4341 375.192 66.3584L384.432 35.3234C384.542 34.9313 384.907 34.6698 385.313 34.6767H473.712C474.214 34.6767 474.627 35.0757 474.627 35.578C474.627 35.6674 474.613 35.7568 474.585 35.8463L465.346 66.8813C465.236 67.2734 464.871 67.5349 464.465 67.528ZM377.284 65.6498H463.791L472.494 36.3829H386.007L377.291 65.6498H377.284Z'
            fill={setup.main}
          />
          <path
            d='M460.2 58.2539H388.422C388.133 58.2539 387.865 58.1163 387.7 57.8824C387.528 57.6554 387.473 57.3595 387.549 57.0843L389.75 49.7091C389.874 49.3239 390.225 49.0624 390.631 49.0624H462.47C462.759 49.0624 463.027 49.2 463.192 49.434C463.358 49.6679 463.413 49.9637 463.33 50.232L461.129 57.6072C461.012 58.0131 460.626 58.2814 460.207 58.2539H460.2ZM389.64 56.4032H459.526L461.177 50.8443H391.305L389.64 56.4032Z'
            fill={setup.main}
          />
          <path d='M423.785 57.3458L425.986 49.9706H390.624L388.415 57.3458H423.785Z' fill={setup.main} />
          <path
            d='M423.785 58.2539H388.36C388.071 58.2539 387.796 58.1163 387.624 57.8824C387.459 57.6485 387.404 57.3527 387.487 57.0843L389.688 49.7092C389.805 49.3239 390.163 49.0556 390.569 49.0624H425.993C426.502 49.0693 426.908 49.489 426.901 49.9981C426.901 50.0738 426.888 50.1563 426.867 50.232L424.665 57.6072C424.555 57.9994 424.191 58.2608 423.785 58.2539ZM389.654 56.4032H423.111L424.762 50.8581H391.305L389.654 56.4032Z'
            fill={setup.main}
          />
          <path
            d='M421.597 43.3178H393.149C392.757 43.2627 392.481 42.8912 392.536 42.4991C392.585 42.1826 392.832 41.9349 393.149 41.8868H421.549C421.941 41.9418 422.216 42.3133 422.161 42.7055C422.113 43.022 421.865 43.2696 421.549 43.3178H421.597Z'
            fill={setup.main}
          />
          <path
            d='M75.7815 180.034H0.928793C0.639839 180.034 0.364646 179.896 0.18577 179.663C1.37529e-05 179.429 -0.0481452 179.119 0.0481727 178.844L20.0135 117.022C20.1373 116.643 20.4813 116.389 20.8803 116.389H95.6849C95.9739 116.389 96.2491 116.526 96.4279 116.76C96.5999 117.001 96.6412 117.304 96.5518 117.579L76.5865 179.401C76.4833 179.759 76.1599 180.013 75.7815 180.034ZM2.18093 178.211H75.1142L94.4809 118.15H21.4995L2.18093 178.211Z'
            fill={setup.main}
          />
          <path
            d='M91.8047 130.052H17.0483C16.546 130.052 16.1401 129.639 16.1401 129.137C16.1401 128.635 16.546 128.229 17.0483 128.229H91.8047C92.3069 128.229 92.7128 128.642 92.7128 129.144C92.7128 129.646 92.3069 130.052 91.8047 130.052Z'
            fill={setup.main}
          />
          <path
            d='M45.0836 135.446L47.8218 134.703L49.2459 134.379C49.7894 134.194 50.3811 134.476 50.5737 135.012C50.7732 135.618 50.9108 136.264 51.0828 136.884C51.1516 137.221 51.2548 137.558 51.3924 137.874C51.4956 138.108 51.6951 138.28 51.9359 138.356C52.9541 138.569 54.0068 138.741 55.025 138.899C55.4378 138.927 55.8437 138.776 56.1395 138.48L58.2585 136.595C58.5268 136.354 58.8226 136.141 59.1391 135.962C59.3593 135.845 59.6207 135.81 59.8684 135.872C61.1343 136.43 62.2901 137.2 63.2808 138.156C63.5973 138.487 63.6248 138.996 63.3565 139.36C62.8955 140.213 62.4414 141.06 61.9667 141.892C61.5746 142.415 61.5333 143.117 61.8567 143.688C62.2763 144.396 62.6616 145.139 63.0744 145.855C63.2326 146.13 63.5422 146.288 63.8656 146.254H67.1541C67.677 146.254 68.0348 146.515 68.0692 147.045C68.1792 148.325 68.2687 149.611 68.3168 150.912C68.3031 151.462 67.966 151.957 67.45 152.164C66.7689 152.501 66.0602 152.769 65.3654 153.079C65.042 153.216 64.698 153.375 64.3884 153.54C63.9619 153.732 63.6317 154.097 63.4734 154.544C63.1501 155.439 62.8405 156.354 62.4827 157.248C62.2488 157.73 62.3245 158.301 62.6822 158.7L64.354 160.557C64.8081 161.018 64.8081 161.754 64.354 162.208C63.5491 163.247 62.8061 164.265 61.8979 165.297C61.5127 165.937 60.7284 166.212 60.0266 165.944C59.5038 165.772 58.9878 165.545 58.4787 165.359C57.9695 165.174 57.7219 165.098 57.3366 164.988C56.972 164.905 56.5936 164.974 56.284 165.187C55.4034 165.745 54.5227 166.302 53.6559 166.873C53.1881 167.169 52.8716 167.65 52.789 168.201C52.7133 168.806 52.6514 169.405 52.5551 169.996C52.507 170.375 52.4313 170.753 52.3418 171.125C52.2249 171.682 51.7983 172.115 51.2411 172.239L47.5466 173.154H46.9756C46.5696 173.209 46.1913 172.955 46.0812 172.569L45.4757 170.327V170.155C45.3725 169.473 44.7878 168.978 44.0998 168.999C43.4049 168.999 42.7376 168.785 42.0565 168.675C41.3685 168.572 40.6736 168.813 40.1989 169.322C39.5316 169.941 38.8711 170.56 38.19 171.145C37.5089 171.73 37.0479 171.84 36.3806 171.42C35.4381 170.815 34.5093 170.182 33.6011 169.535C33.1058 169.178 33.0439 168.73 33.3672 168.084C33.6906 167.437 34.0965 166.756 34.468 166.089C35.2729 164.651 35.2867 164.417 34.6056 163.213L33.7869 161.823C33.5186 161.266 32.8994 160.977 32.3008 161.128C31.606 161.128 30.8974 161.252 30.1956 161.266C29.8654 161.252 29.5283 161.204 29.2049 161.128C28.8747 161.114 28.6132 160.839 28.5995 160.509C28.5995 159.271 28.4619 158.039 28.4 156.815C28.3862 156.643 28.3862 156.464 28.4 156.292C28.4619 155.838 28.7646 155.445 29.1912 155.273L31.6335 154.207L32.3628 153.836C32.7687 153.643 33.0714 153.299 33.2159 152.879C33.5117 152.012 33.8213 151.132 34.1309 150.265C34.3373 149.811 34.2341 149.274 33.8832 148.923L32.3352 147.272C31.7298 146.529 31.7161 146.171 32.4453 145.263C33.1746 144.355 33.9933 143.241 34.9152 142.25C35.2385 141.727 35.8921 141.514 36.4631 141.741C37.1718 141.988 37.8666 142.25 38.5477 142.56C39.2632 142.869 40.0888 142.752 40.6943 142.264C41.4648 141.72 42.2422 141.225 43.0265 140.716C43.3568 140.516 43.5838 140.186 43.6595 139.801C43.7971 138.948 43.9209 138.115 44.0585 137.283C44.1135 136.712 44.3406 136.175 44.7052 135.735L45.063 135.46L45.0836 135.446ZM51.53 160.296C55.7474 157.73 57.6324 152.755 55.8299 149.027C54.282 145.938 49.6449 144.39 45.0079 147.141C40.88 149.66 38.933 154.682 40.6943 158.287C42.827 162.539 48.2827 162.525 51.53 160.296Z'
            fill={setup.main}
          />
          <path
            d='M46.9069 173.994C46.0882 174.062 45.3314 173.533 45.1112 172.741L44.5058 170.485V170.272C44.5058 170.024 44.4164 169.886 43.9485 169.838C43.4807 169.79 42.9441 169.701 42.4006 169.625L41.7814 169.515C41.3755 169.453 40.9695 169.604 40.7012 169.914C40.0408 170.554 39.3597 171.173 38.6579 171.771C37.9287 172.618 36.6765 172.769 35.7684 172.129C34.8121 171.51 33.8695 170.877 32.9545 170.21C32.0877 169.646 31.8469 168.483 32.411 167.623C32.411 167.616 32.4179 167.609 32.4248 167.602C32.7 167.045 33.0096 166.501 33.3192 165.951L33.5324 165.58C33.9544 164.837 34.0003 164.183 33.67 163.619L32.8651 162.229C32.7825 162.057 32.5899 161.968 32.4041 162.016H31.7093L30.2714 162.091C29.8517 162.112 29.432 162.085 29.0193 162.016C28.2418 161.919 27.6502 161.259 27.657 160.468L27.5814 159.25C27.5814 158.418 27.5057 157.599 27.4575 156.76C27.43 156.539 27.43 156.312 27.4575 156.092C27.5676 155.322 28.0698 154.661 28.7853 154.345L31.2277 153.278L31.8744 152.955C32.0808 152.872 32.239 152.7 32.3078 152.494C32.583 151.675 32.8788 150.946 33.1609 150.052V149.866C33.2504 149.605 33.1609 149.543 33.1609 149.446L32.0601 148.242L31.6611 147.795C30.7599 146.983 30.6911 145.594 31.5029 144.692C31.551 144.637 31.6061 144.582 31.6611 144.534C32.4661 143.495 33.3123 142.491 34.1654 141.445C34.7364 140.619 35.8028 140.303 36.7316 140.674C37.4746 140.936 38.2795 141.197 38.8987 141.528C39.3253 141.7 39.8069 141.617 40.1508 141.314C40.6324 140.977 41.1278 140.647 41.6988 140.324L42.5794 139.753C42.7927 139.615 42.8133 139.491 42.8133 139.443L42.9853 138.404C43.061 137.909 43.1367 137.413 43.233 136.856C43.3018 136.093 43.6114 135.377 44.1136 134.799C44.1687 134.737 44.2306 134.689 44.2994 134.648L44.5952 134.476C44.664 134.428 44.7466 134.393 44.8291 134.366L45.5859 134.166L47.5811 133.623C48.0764 133.485 48.558 133.389 49.129 133.286C50.1266 132.997 51.1724 133.54 51.5095 134.524C51.6471 134.944 51.7571 135.377 51.8672 135.804L52.1149 136.719C52.1562 136.904 52.2112 137.083 52.2869 137.262C53.2019 137.475 54.2201 137.647 55.2521 137.806C55.3966 137.771 55.5204 137.696 55.6236 137.592L56.5386 136.774L57.7426 135.721C58.066 135.425 58.4237 135.164 58.809 134.95C59.2906 134.703 59.8478 134.668 60.357 134.84C61.7192 135.446 62.9713 136.285 64.0377 137.331C64.6362 137.95 64.7325 138.893 64.2716 139.615L63.7762 140.53C63.4804 141.074 63.1915 141.631 62.8612 142.167C62.531 142.704 62.6617 142.897 62.7374 143.021C63.0332 143.481 63.2809 143.963 63.5423 144.445L63.9758 145.215C64.3129 145.146 64.65 145.112 64.994 145.105H67.2368C68.1862 145.05 68.9912 145.779 69.0462 146.722C69.1563 148.022 69.2457 149.316 69.2939 150.616C69.3145 151.531 68.7779 152.37 67.9317 152.735C67.4501 152.969 66.9754 153.168 66.4938 153.368L65.7989 153.664L64.8701 154.097C64.65 154.2 64.478 154.379 64.3885 154.606L64.1753 155.212C63.9276 155.92 63.6799 156.636 63.4047 157.331C63.2809 157.654 63.4047 157.75 63.4047 157.853C63.4047 157.957 63.9482 158.459 64.2234 158.768C64.4986 159.078 64.7945 159.388 65.0765 159.711C65.8195 160.502 65.8195 161.734 65.0765 162.525C64.2578 163.564 63.4391 164.596 62.6067 165.614C62.0012 166.57 60.8041 166.962 59.7446 166.556L58.7677 166.199L58.1623 165.965C57.8114 165.827 57.4468 165.717 57.0821 165.628C57.0821 165.628 56.9445 165.628 56.7726 165.703L56.229 166.04L54.1582 167.368C53.9037 167.52 53.7317 167.774 53.6973 168.063L53.5872 168.854C53.5872 169.191 53.5115 169.535 53.4633 169.873C53.4152 170.21 53.3258 170.678 53.2294 171.077C53.0299 171.957 52.3488 172.652 51.4682 172.872L47.76 173.767C47.526 173.822 47.2852 173.842 47.0513 173.842L46.9137 174.014L46.9069 173.994ZM46.7693 172.157L46.8931 173.085V172.157H47.2164C48.4548 171.861 49.6726 171.572 50.9109 171.242C51.0829 171.242 51.248 171.118 51.3444 170.794C51.4407 170.471 51.482 170.113 51.5301 169.776L51.6677 168.786L51.7778 167.981C51.8879 167.169 52.3488 166.453 53.0437 166.02L55.1489 164.658L55.6718 164.321C56.1946 163.97 56.8414 163.86 57.4468 164.011C57.8664 164.121 58.2655 164.259 58.6645 164.396L59.3319 164.658L60.185 164.967C60.5427 165.091 60.6665 165.119 61.0656 164.609C61.898 163.605 62.703 162.587 63.5079 161.52C63.7556 161.211 63.7074 161.163 63.5974 161.039L62.7787 160.11L61.9462 159.168C61.3545 158.521 61.2101 157.585 61.5747 156.787C61.8361 156.106 62.0838 155.411 62.3315 154.73L62.5447 154.111C62.7718 153.437 63.2534 152.886 63.8863 152.563C64.2234 152.391 64.5812 152.226 64.9252 152.081L65.6544 151.772C66.1016 151.586 66.5351 151.4 66.9685 151.187C67.1405 151.097 67.34 150.939 67.34 150.788C67.34 149.508 67.2024 148.222 67.0923 146.956C66.7002 147.011 66.3011 147.038 65.9021 147.045H63.8588C63.2327 147.031 62.6479 146.708 62.3108 146.178L61.8636 145.387C61.616 144.94 61.3683 144.472 61.1069 144.046C60.5977 143.193 60.6459 142.119 61.2169 141.307C61.5265 140.785 61.8017 140.255 62.0838 139.759L62.5929 138.831C62.6067 138.776 62.6067 138.714 62.5929 138.659C61.7054 137.84 60.6941 137.166 59.5933 136.664C59.3181 136.801 59.0635 136.98 58.8365 137.186L57.6463 138.239L56.7175 139.058C56.2359 139.539 55.5548 139.78 54.8806 139.704C53.8142 139.553 52.7478 139.381 51.709 139.147C51.2068 139.01 50.7871 138.672 50.5532 138.205C50.4087 137.902 50.2986 137.585 50.2298 137.262L49.9959 136.368C49.8858 135.969 49.7964 135.577 49.6726 135.212H49.3974L48.0214 135.521L46.0606 136.065L45.352 136.278C45.1594 136.581 45.0493 136.925 45.0287 137.283L44.609 139.801C44.5127 140.441 44.1412 141.005 43.5908 141.349L42.6964 141.934L41.2585 142.91C40.3779 143.605 39.1877 143.75 38.1694 143.282C37.5227 142.986 36.8554 142.738 36.1605 142.491C35.8991 142.401 35.8647 142.401 35.5895 142.725C34.757 143.715 33.9177 144.706 33.1334 145.711C32.9889 145.883 32.872 146.068 32.7757 146.268C32.7757 146.268 32.7757 146.357 33.0233 146.591L33.4568 147.073C33.7939 147.472 34.1516 147.864 34.5094 148.249C35.101 148.855 35.2799 149.756 34.9566 150.533V150.705L34.1035 153.134C33.8902 153.774 33.4292 154.303 32.8238 154.599C32.5624 154.751 32.3009 154.874 32.0326 154.998L29.5903 156.065C29.4527 156.12 29.3564 156.25 29.3426 156.402C29.3357 156.512 29.3357 156.615 29.3426 156.725C29.3426 157.544 29.3426 158.363 29.4664 159.195V160.199C29.7141 160.22 29.9618 160.22 30.2095 160.199L31.5717 160.124H32.2803C33.1678 160.027 34.0278 160.475 34.4612 161.252L35.2662 162.656C36.1193 163.784 36.0711 165.359 35.1423 166.426L34.929 166.811C34.6332 167.32 34.3236 167.85 34.0622 168.359C34.0071 168.442 33.9727 168.538 33.9521 168.634C34.9084 169.281 35.8234 169.9 36.7522 170.506L36.9999 170.629C37.1719 170.554 37.3301 170.444 37.4608 170.306C38.1282 169.721 38.7886 169.116 39.4422 168.497C40.1233 167.795 41.1071 167.471 42.0703 167.63L42.717 167.74C43.1505 167.74 43.5977 167.891 44.0586 167.939C45.1456 167.96 46.0675 168.765 46.2395 169.838L46.8862 172.17C46.8862 172.17 46.8174 172.129 46.7761 172.122L46.7693 172.157ZM46.7693 162.697C46.0262 162.697 45.2901 162.607 44.5746 162.422C42.545 161.947 40.8388 160.578 39.9376 158.7C37.9562 154.682 40.0476 149.15 44.5746 146.337C46.8587 144.851 49.6726 144.41 52.3007 145.119C54.172 145.628 55.7475 146.894 56.6418 148.614C58.6645 152.769 56.6418 158.225 52.0048 161.053C50.4362 162.112 48.5855 162.676 46.6867 162.676L46.7624 162.704L46.7693 162.697ZM49.9546 146.626C48.4067 146.653 46.9 147.107 45.5928 147.94C41.9121 150.182 40.1096 154.737 41.6507 157.895C42.3111 159.271 43.5495 160.289 45.0355 160.66C47.1201 161.142 49.3148 160.743 51.0967 159.546C54.9288 157.227 56.6625 152.79 55.0526 149.453C54.3784 148.201 53.2157 147.286 51.8397 146.935C51.2068 146.736 50.5463 146.632 49.8789 146.626H49.9546Z'
            fill={setup.main}
          />
          <path
            d='M213.069 113.024C218.015 119.87 228.308 119.037 235.16 116.017C236.371 115.48 235.325 113.705 234.121 114.235C230.681 115.749 226.794 116.471 223.038 116.1C219.956 115.79 216.715 114.565 214.851 111.979C214.08 110.912 212.291 111.944 213.069 113.018V113.024Z'
            fill='#262235'
          />
        </g>
        <defs>
          <filter
            id='filter0_d_126_807'
            x='18.5547'
            y='166.267'
            width='154.275'
            height='154.275'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='0.95' dy='0.95' />
            <feGaussianBlur stdDeviation='14.18' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.0941176 0 0 0 0 0.0705882 0 0 0 0 0.490196 0 0 0 0.25 0'
            />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_126_807' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_126_807' result='shape' />
          </filter>
          <filter
            id='filter1_d_126_807'
            x='211.91'
            y='-21.4108'
            width='149.989'
            height='149.941'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='0.93' dy='0.93' />
            <feGaussianBlur stdDeviation='13.92' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.0941176 0 0 0 0 0.0705882 0 0 0 0 0.490196 0 0 0 0.25 0'
            />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_126_807' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_126_807' result='shape' />
          </filter>
          <filter
            id='filter2_d_126_807'
            x='20.4668'
            y='-23.156'
            width='152.735'
            height='152.735'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='0.95' dy='0.95' />
            <feGaussianBlur stdDeviation='14.18' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.0941176 0 0 0 0 0.0705882 0 0 0 0 0.490196 0 0 0 0.25 0'
            />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_126_807' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_126_807' result='shape' />
          </filter>
          <filter
            id='filter3_d_126_807'
            x='355.275'
            y='71.0709'
            width='154.275'
            height='154.275'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='0.95' dy='0.95' />
            <feGaussianBlur stdDeviation='14.18' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.0941176 0 0 0 0 0.0705882 0 0 0 0 0.490196 0 0 0 0.25 0'
            />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_126_807' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_126_807' result='shape' />
          </filter>
          <filter
            id='filter4_d_126_807'
            x='304.956'
            y='262.792'
            width='154.275'
            height='154.275'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='0.95' dy='0.95' />
            <feGaussianBlur stdDeviation='14.18' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.0941176 0 0 0 0 0.0705882 0 0 0 0 0.490196 0 0 0 0.25 0'
            />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_126_807' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_126_807' result='shape' />
          </filter>
          <linearGradient
            id='paint0_linear_126_807'
            x1='287.082'
            y1='4.06159'
            x2='286.266'
            y2='429.187'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.bg.main} stopOpacity='0' />
            <stop offset='0.88' stopColor={setup.main} />
          </linearGradient>
          <linearGradient
            id='paint1_linear_126_807'
            x1='47.0024'
            y1='52.1891'
            x2='334.139'
            y2='52.7403'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.bg.main} stopOpacity='0.5' />
            <stop offset='0.31' stopColor={setup.bg.dark} stopOpacity='0.58' />
            <stop offset='1' stopColor={setup.dark} stopOpacity='0.8' />
          </linearGradient>
          <linearGradient
            id='paint2_linear_126_807'
            x1='94.8319'
            y1='204.768'
            x2='94.2854'
            y2='489.44'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.main} stopOpacity='0.6' />
            <stop offset='0.68' stopColor={setup.bg.main} stopOpacity='0' />
          </linearGradient>
          <linearGradient
            id='paint3_linear_126_807'
            x1='399.111'
            y1='147.203'
            x2='540.635'
            y2='147.475'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0.02' stopColor={setup.main} stopOpacity='0.6' />
            <stop offset='0.92' stopColor={setup.bg.main} stopOpacity='0' />
          </linearGradient>
          <linearGradient
            id='paint4_linear_126_807'
            x1='272.522'
            y1='242.868'
            x2='-50.856'
            y2='242.247'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.bg.main} stopOpacity='0.3' />
            <stop offset='1' stopColor={setup.main} />
          </linearGradient>
          <linearGradient
            id='paint5_linear_126_807'
            x1='160.96'
            y1='338.423'
            x2='428.861'
            y2='338.938'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.bg.light} stopOpacity='0.2' />
            <stop offset='0.26' stopColor={setup.bg.light} stopOpacity='0.34' />
            <stop offset='0.83' stopColor={setup.info.light} stopOpacity='0.69' />
            <stop offset='1' stopColor={setup.main} stopOpacity='0.8' />
          </linearGradient>
          <linearGradient
            id='paint6_linear_126_807'
            x1='332.606'
            y1='338.979'
            x2='429.681'
            y2='338.979'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.bg.main} stopOpacity='0.3' />
            <stop offset='1' stopColor={setup.main} />
          </linearGradient>
          <clipPath id='clip0_126_807'>
            <rect width='480' height='389.688' fill='white' transform='translate(0 0.655884)' />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}

export default LoginGirlSVG
